// src/components/GoogleMapsLoader.tsx
import { useJsApiLoader } from "@react-google-maps/api";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export const GoogleMapsLoader = ({ children }: Props) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_PUBLIC_GOOGLE_MAPS_API_KEY || "",
  });

  if (!isLoaded) {
    return <div>Loading Google Maps...</div>;
  }

  return <>{children}</>;
};
